

















































import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'
import { Getter, namespace } from 'vuex-class'
import MultilineInput from 'vuecomponents/multiline_input.vue'
import attachmentCaptionForDisplay from 'surface/attachment_caption_for_display'

@Component({ components: { MultilineInput } })
export default class BeethovenAttachmentCaption extends Mixins() {
  $refs!: {
    input: MultilineInput
  }
  @Prop() caption!: string | null | undefined
  @Prop() attachmentTitle!: string
  @Prop({ default: true }) canEditInline!: boolean
  @Prop({ default: true }) xPlaceholder!: boolean
  /**
   * How the component should decide to show dark mode: Using browser or with custom isDark prop
   */
  @Prop({ default: 'browser' }) darkThemeType!: 'browser' | 'custom'
  @Prop({ default: 'browser' }) isDark!: false
  @Prop({ required: true }) usageContext!: 'postModal' | 'postView'

  @Getter('isStream') isPadletStreamFormat!: boolean
  @Getter dir!: string
  @namespace('browser').Getter isPhone!: boolean

  editing = false
  focusingOnLoad = false

  public focusOnLoad(): void {
    this.focusingOnLoad = true
  }

  @Watch('canEditInline')
  handleWhenCaptionEditable(canEditInline: boolean): void {
    this.$nextTick(() => {
      if (canEditInline && this.focusingOnLoad && this.$refs.input) {
        this.$refs.input.focus()
      }
    })
  }

  get captionBeingDisplayed(): string {
    return attachmentCaptionForDisplay({
      postAttachmentCaption: this.caption,
      defaultCaption: this.attachmentTitle,
    })
  }

  get xBigCaption(): boolean {
    if (this.usageContext === 'postView') {
      return this.isPadletStreamFormat
    } else if (this.usageContext === 'postModal') {
      return !this.isPhone
    }
    return false
  }

  onChange(newValue: string): void {
    const changedValue = newValue === this.attachmentTitle ? null : newValue
    this.$emit('change', changedValue)
  }

  onEditStart(): void {
    this.$emit('edit-start')
    if (!this.canEditInline) return
    this.editing = true
  }

  onEditEnd(): void {
    this.editing = false
  }

  mounted(): void {
    this.$nextTick(() => {
      if (this.canEditInline && this.focusingOnLoad && this.$refs.input) {
        this.$refs.input.focus()
      }
    })
  }
}
